var _path, _path2, _circle, _circle2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRedeem = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.524016 15.7384H1.57205C1.86145 15.7384 2.09607 15.5038 2.09607 15.2144V9.4502H0.524016C0.23462 9.4502 0 9.68481 0 9.97421V15.2144C0 15.5037 0.23462 15.7384 0.524016 15.7384Z",
    fill: "#5D5CF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C8.79083 0 7 1.79083 7 4C7 6.2091 8.79083 8 11 8C13.2092 8 15 6.2091 15 4C15 1.79083 13.2092 0 11 0Z",
    fill: "#5D5CF5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 4,
    r: 3,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.9992,
    cy: 4.0002,
    r: 2.3,
    fill: "#5D5CF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46071 16.018H9.57599C11.3367 15.997 13.024 15.4975 14.5123 14.5961L17.4362 12.5525C17.9288 12.2066 18.0231 11.5568 17.6982 11.0957C17.3629 10.6136 16.7131 10.4983 16.2415 10.8337L13.4328 12.804C12.5314 13.328 11.431 13.4433 10.4354 13.1079L7.20395 12.0389C6.93146 11.9551 6.7847 11.6511 6.87906 11.3787C6.96286 11.1167 7.23535 10.9699 7.50784 11.0433C7.51832 11.0433 11.1375 12.2171 11.1375 12.2171C11.747 12.3998 12.2885 12.0549 12.458 11.5464C12.6362 10.9909 12.3323 10.404 11.7873 10.2258L6.85806 8.61187C5.77991 8.21938 4.32703 8.30046 3.14453 8.9617V14.828L7.25631 15.7594C8.00953 15.9251 8.74861 16.018 9.46071 16.018Z",
    fill: "#5D5CF5"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRedeem, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/redeem.44acee8f.svg";
export { ForwardRef as ReactComponent };